import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/rawan/Header";
import { Footer } from "@/components/rawan/Footer";
import { EditableStaticPage } from "@/components/rawan/EditableStaticPage";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "شروط الاستخدام — Rawan UI" },
      { name: "description", content: "شروط استخدام موقع Rawan UI لعرض الأفلام والمسلسلات." },
    ],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="min-h-dvh flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 max-w-3xl">
        <EditableStaticPage
          pageKey="terms"
          titleAr="شروط الاستخدام"
          titleEn="Terms of Use"
          titleFr="Conditions d'utilisation"
          defaultParagraphsAr={[
            "## الموافقة\n\nباستخدامك للموقع فأنت توافق على هذه الشروط. المحتوى المعروض **لأغراض العرض التوضيحي** فقط.",
            "## الاستخدام المسموح\n\n- يُمنع إعادة نشر أو نسخ أي جزء من الموقع دون إذن مسبق.\n- الروابط الخارجية مسؤولية أصحابها.",
            "## التعديلات\n\nنحتفظ بحق تعديل هذه الشروط في أي وقت، ويُعدّ استخدامك المستمر للموقع موافقةً على التعديلات.",
          ]}
          defaultParagraphsEn={[
            "## Acceptance\n\nBy using this site, you agree to these terms. The content is provided **for demonstration purposes only**.",
            "## Allowed Use\n\n- Reproducing or copying any part of the site without prior permission is prohibited.\n- External links are the responsibility of their owners.",
            "## Updates\n\nWe reserve the right to update these terms at any time; continued use constitutes acceptance of any changes.",
          ]}
          defaultParagraphsFr={[
            "## Acceptation\n\nEn utilisant ce site, vous acceptez ces conditions. Le contenu est fourni **à des fins de démonstration uniquement**.",
            "## Utilisation autorisée\n\n- Toute reproduction ou copie d'une partie du site sans autorisation préalable est interdite.\n- Les liens externes relèvent de la responsabilité de leurs propriétaires.",
            "## Mises à jour\n\nNous nous réservons le droit de modifier ces conditions à tout moment ; l'utilisation continue vaut acceptation.",
          ]}
        />
      </main>
      <Footer />
    </div>
  );
}
